import React from 'react';
import Pagination from './Pagination';
export default (props) => {
  return <Pagination {...props}></Pagination>;
};
